var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4625 0.455092C12.1238 0.161271 11.6941 0 11.25 0C10.8059 0 10.3762 0.161271 10.0375 0.455092L0.6625 8.59286C0.454907 8.77292 0.288115 8.99707 0.17371 9.24972C0.0593046 9.50238 2.88643e-05 9.77749 0 10.0559V22.0816C0 22.5904 0.197544 23.0784 0.549175 23.4381C0.900806 23.7979 1.37772 24 1.875 24H7.8125C8.06114 24 8.2996 23.8989 8.47541 23.7191C8.65123 23.5392 8.75 23.2952 8.75 23.0408V15.0476H13.75V23.0408C13.75 23.5703 14.17 24 14.6875 24H20.625C21.1223 24 21.5992 23.7979 21.9508 23.4381C22.3025 23.0784 22.5 22.5904 22.5 22.0816V10.0559C22.5 9.77749 22.4407 9.50238 22.3263 9.24972C22.2119 8.99707 22.0451 8.77292 21.8375 8.59286L12.4625 0.455092Z",
    fill: "white",
    fillOpacity: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.a2445da08780d8f5b1c182fa9721e1c4.svg";
export { ForwardRef as ReactComponent };